import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
	Container,
	Center,
	Paper,
	Title,
	Button,
	Text,
	Space,
	Alert,
	PasswordInput,
	TextInput,
} from '@mantine/core'
import { AlertCircle } from 'tabler-icons-react'
import { getCurrentUser } from '../services/actions/userActions'
import { loginWithEmail } from '../services/actions/authActions'

const LoginPage = () => {
	const navigate = useNavigate()
	const [error, setError] = useState(null)
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [submitting, setSubmitting] = useState(false)

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)
		const token = urlParams.get('token')
		const errorParam = urlParams.get('error')

		if (errorParam === 'user_not_found') {
			setError(
				'Login failed: there is no account associated with that email. Please contact your administrator.'
			)

			const timer = setTimeout(() => setError(null), 10000)
			return () => clearTimeout(timer)
		}

		const handleLogin = async () => {
			if (token) {
				localStorage.setItem('token', token)

				try {
					const user = await getCurrentUser()
					navigate(
						user?.currentExperienceSlug ? `/${user.currentExperienceSlug}` : '/'
					)
				} catch (err) {
					console.error('Failed to fetch user after login', err)
					navigate('/')
				}
			}
		}

		handleLogin()
	}, [navigate])

	const handleGoogleLogin = () => {
		const isLocalhost = window.location.hostname === 'localhost'
		const backendUrl = isLocalhost
			? 'http://localhost:3001'
			: process.env.REACT_APP_API_URL

		window.location.href = `${backendUrl}/auth/google`
	}

	const handleEmailLogin = async () => {
		setSubmitting(true)
		setError(null)

		try {
			const token = await loginWithEmail(email, password)
			localStorage.setItem('token', token)

			const user = await getCurrentUser()
			navigate(
				user?.currentExperienceSlug ? `/${user.currentExperienceSlug}` : '/'
			)
		} catch (err) {
			console.error('Login failed:', err)
			setError(err.message || 'Login failed')
		} finally {
			setSubmitting(false)
		}
	}

	return (
		<Container size='xs'>
			<Center style={{ height: '100vh' }}>
				<Paper withBorder shadow='sm' p='xl' radius='md' w='100%'>
					<Title align='center' order={2} mb='md'>
						Welcome to LiveHQ
					</Title>

					<Text align='center' c='dimmed' size='sm'>
						Sign in to get started
					</Text>

					<Space h='lg' />

					{error && (
						<Alert
							icon={<AlertCircle size={16} />}
							title='Authentication Error'
							color='red'
							mb='md'
						>
							{error}
						</Alert>
					)}

					<TextInput
						label='Email'
						placeholder='you@example.com'
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						mb='sm'
					/>

					<PasswordInput
						label='Password'
						placeholder='••••••••'
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						mb='md'
					/>

					<Button
						fullWidth
						onClick={handleEmailLogin}
						loading={submitting}
						mb='sm'
					>
						Login with Email
					</Button>

					<Text align='center' size='sm' c='dimmed' mb='sm'>
						OR
					</Text>

					<Button fullWidth variant='outline' onClick={handleGoogleLogin}>
						Login with Google
					</Button>
				</Paper>
			</Center>
		</Container>
	)
}

export default LoginPage
